export default __webpack_public_path__ + "static/media/835.4473b809.png";